/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".map-action{padding:5px 10px;cursor:pointer}.map-action:hover{background-color:#f7f7f7}"];
export { styles as styles };
